import React, { Fragment, memo } from 'react';
import { string, func } from 'prop-types';
import { UTLabel, UTTouchableWithoutFeedback, WithLoading } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { codeField } from 'constants/fields';
import UTForm from 'app/components/UTForm';

import styles from './styles';

const fields = [{ ...codeField, title: message('Configuration:validateCodePlaceholder') }];

const ValidateEmail = ({ newEmail, onResendCode }) => (
  <Fragment>
    <UTLabel gray>{message('Signup:codeSent', { userEmail: newEmail })}</UTLabel>
    <UTForm fields={fields} />
    <div style={styles.resendMail}>
      <UTLabel bold small darkGray>
        {message('Signup:missingMail')}
      </UTLabel>
      <UTTouchableWithoutFeedback onClick={onResendCode}>
        <UTLabel bold primary small>
          &nbsp;
          {message('Signup:resend')}
        </UTLabel>
      </UTTouchableWithoutFeedback>
    </div>
  </Fragment>
);

ValidateEmail.propTypes = {
  newEmail: string,
  onResendCode: func
};

export default WithLoading(props => props.loading)(memo(ValidateEmail));
